import HeroBanner from './HeroBanner';
import CardsBanner from './CardsBanner';
import Card from './Card';
import NosMarques from './NosMarques';
import HeroPhoto from './HeroPhoto';
import QuiSommesNousBanner from './QuiSommesNousBanner';
import LatestBlogBanner from './LatestBlogBanner';
import PostCard from './PostCard';
import ButtonVoirTous from './ButtonVoirTous';

export {
  HeroBanner,
  CardsBanner,
  Card,
  NosMarques,
  HeroPhoto,
  QuiSommesNousBanner,
  LatestBlogBanner,
  PostCard,
  ButtonVoirTous,
};



// WEBPACK FOOTER //
// ./src/components/Main/home/index.js